import {
  GET_CLIENT_DOWNLOAD_DUMP_ADIB,
  GET_CLIENT_DOWNLOAD_DUMP_ADIB_SUCCESS,
  GET_CLIENT_DOWNLOAD_DUMP_ADIB_ERROR,
  GET_CLIENT_DOWNLOAD_DUMP_ADIB_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientDownloadDumpADIB = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_DOWNLOAD_DUMP_ADIB:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_DOWNLOAD_DUMP_ADIB_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CLIENT_DOWNLOAD_DUMP_ADIB_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CLIENT_DOWNLOAD_DUMP_ADIB_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientDownloadDumpADIB;
